<template>
  <div class="mainbody">
    <!-- 相册列表视图 -->
    <template v-if="viewMode === 'list'">
      <!-- 顶部操作栏 -->
      <div style="padding: 16px 32px 16px 0px">
        <span class="title">相册</span>
        <div style="float: right">
          <el-button type="primary" size="small" @click="handleCreate">创建相册</el-button>
        </div>
      </div>

      <!-- 搜索和筛选区域 -->
      <div style="padding: 16px 32px; background: #fafafa; margin-bottom: 16px;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="搜索">
            <el-input
              v-model="searchForm.search"
              placeholder="请输入标题/描述"
              clearable
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-select
              v-model="searchForm.screen_is_show"
              placeholder="请选择"
              clearable
            >
              <el-option label="未发布" :value="0"></el-option>
              <el-option label="已发布" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 相册列表表格 -->
      <div class="tableInfo" style="margin: 0 32px;">
        <el-table
          :data="dataList"
          style="width: 100%"
          v-loading="loading"
          key="album-list-table"
        >
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="title" label="标题" min-width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="enterAlbum(scope.row)">{{ scope.row.title }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
          <el-table-column prop="photo_count" label="照片总数" width="100"></el-table-column>
          <el-table-column prop="uploader_name" label="创建人" width="120"></el-table-column>
          <el-table-column prop="upload_time" label="创建时间" width="160"></el-table-column>
          <el-table-column prop="is_show_text" label="是否发布" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_show === 1 ? 'success' : 'info'" size="small">
                {{ scope.row.is_show_text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="enterAlbum(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          :key="elementui_page_key"
          class="elPagination"
          background
          layout="prev, pager, next"
          :page-size="pageMaxSize"
          :page-count="pageCount"
          :current-page="currentPage"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </template>

    <!-- 相册详情视图（照片/视频列表） -->
    <template v-if="viewMode === 'detail'">
      <!-- 标题导航 -->
      <div style="padding: 16px 32px 16px 0px">
        <span class="title" style="cursor: pointer; padding-right: 0;" @click="backToList">相册</span>
        <span class="title" style="padding-left: 0; padding-right: 0;">/</span>
        <span class="title" style="padding-left: 0;">{{ albumInfo.title }}</span>
        <div style="float: right">
          <el-button type="primary" size="small" @click="handleUploadPhoto">上传照片/视频</el-button>
          <el-button size="small" @click="downloadAlbum">下载相册</el-button>
        </div>
      </div>

      <!-- 描述区域 -->
      <div style="padding: 12px 32px; background: #fafafa; margin-bottom: 16px;" v-if="albumInfo.description">
        <span style="color: #666; font-size: 13px;">{{ albumInfo.description }}</span>
      </div>

      <!-- 照片/视频列表表格 -->
      <div class="tableInfo" style="margin: 0 32px;">
        <el-table
          :data="photoList"
          style="width: 100%"
          v-loading="detailLoading"
          key="album-detail-table"
          row-key="id"
          ref="photoTable"
        >
          <el-table-column label="排序" width="70">
            <template slot-scope="scope">
              <span class="drag-handle"><span></span><span></span><span></span></span>{{ scope.row.sort }}
            </template>
          </el-table-column>
          <el-table-column label="预览" width="100">
            <template slot-scope="scope">
              <el-image
                v-if="!scope.row.is_video"
                style="width: 60px; height: 60px; cursor: pointer;"
                :src="getFileUrl(scope.row.file_path)"
                fit="cover"
                :preview-src-list="[getFileUrl(scope.row.file_path)]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div v-else class="thumbnail-video" @click="previewItem(scope.row)">
                <i class="el-icon-video-play"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_video ? 'warning' : ''" size="mini">
                {{ scope.row.is_video ? '视频' : '图片' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.description || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="file_name" label="文件名" min-width="150"></el-table-column>
          <el-table-column prop="file_size_format" label="大小" width="110"></el-table-column>
          <el-table-column prop="upload_time" label="上传时间" width="160"></el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEditPhoto(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="downloadPhoto(scope.row)">下载</el-button>
              <el-button type="text" size="small" @click="handleDeletePhoto(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 排序操作 -->
        <div style="margin-top: 16px; text-align: right;">
          <el-button v-if="sortChanged" type="primary" size="small" @click="saveSort" :loading="sortSaving">保存排序</el-button>
          <el-button v-if="sortChanged" size="small" @click="cancelSort">取消</el-button>
          <span v-if="!sortChanged" style="color: #909399; font-size: 13px;"><i class="el-icon-rank" style="margin-right: 4px;"></i>拖拽行可排序</span>
        </div>
      </div>
    </template>

    <!-- 创建/编辑相册弹窗 -->
    <el-dialog
      :title="isEdit ? '编辑相册' : '创建相册'"
      :visible.sync="createDialogVisible"
      width="500px"
      :before-close="handleCloseCreateDialog"
    >
      <el-form :model="createForm" :rules="createRules" ref="createForm" label-width="100px">
        <el-form-item label="相册标题" prop="title">
          <el-input
            v-model="createForm.title"
            placeholder="请输入相册标题"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="createForm.description"
            type="textarea"
            :rows="3"
            placeholder="请输入描述"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="是否发布" prop="is_show">
          <el-select
            v-model="createForm.is_show"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="未发布" :value="0"></el-option>
            <el-option label="已发布" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCreateDialog">取 消</el-button>
        <el-button type="primary" @click="submitCreate" :loading="createLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 视频预览弹窗 -->
    <el-dialog
      title="视频播放"
      :visible.sync="videoPreviewVisible"
      width="800px"
      :append-to-body="true"
      @close="closeVideoPreview"
    >
      <div style="text-align: center;">
        <video
          ref="previewVideo"
          :src="videoPreviewUrl"
          controls
          style="width: 100%; max-height: 70vh;"
        ></video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeVideoPreview">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 上传照片/视频弹窗 -->
    <el-dialog
      title="上传照片/视频"
      :visible.sync="uploadDialogVisible"
      width="700px"
      :before-close="handleCloseUploadDialog"
      :close-on-click-modal="false"
    >
      <el-upload
        ref="photoUpload"
        action="#"
        :auto-upload="false"
        :on-change="handleUploadFileChange"
        :on-remove="handleUploadFileRemove"
        :limit="100"
        multiple
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          支持批量选择文件，大文件自动分片上传（5MB/片），文件将依次上传
        </div>
      </el-upload>

      <!-- 已选择的文件列表 -->
      <div v-if="uploadFileList.length > 0" style="margin-top: 16px; max-height: 400px; overflow-y: auto;">
        <el-table :data="uploadFileList" style="width: 100%" size="small">
          <el-table-column prop="name" label="文件名" min-width="180"></el-table-column>
          <el-table-column label="大小" width="100">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <!-- 计算hash中 -->
              <el-tag v-if="uploadFileStatusMap[scope.row.uid] === 'hashing'" type="info" size="mini">计算中...</el-tag>
              <!-- 上传中 -->
              <el-tag v-else-if="uploadFileStatusMap[scope.row.uid] === 'uploading'" type="warning" size="mini">上传中</el-tag>
              <!-- 合并中 -->
              <el-tag v-else-if="uploadFileStatusMap[scope.row.uid] === 'merging'" type="warning" size="mini">合并中...</el-tag>
              <!-- 已上传成功 -->
              <el-tag v-else-if="uploadFileStatusMap[scope.row.uid] === 'success'" type="success" size="mini">已上传</el-tag>
              <!-- 上传失败 -->
              <el-tag v-else-if="uploadFileStatusMap[scope.row.uid] === 'error'" type="danger" size="mini" effect="plain">失败</el-tag>
              <!-- 待上传 -->
              <el-tag v-else type="info" size="mini" effect="plain">待上传</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="进度" width="160">
            <template slot-scope="scope">
              <el-progress
                v-if="uploadFileStatusMap[scope.row.uid] === 'uploading' || uploadFileStatusMap[scope.row.uid] === 'merging' || uploadFileStatusMap[scope.row.uid] === 'success'"
                :percentage="uploadFileProgressMap[scope.row.uid] || 0"
                :status="uploadFileStatusMap[scope.row.uid] === 'success' ? 'success' : (uploadFileStatusMap[scope.row.uid] === 'error' ? 'exception' : '')"
                :stroke-width="14"
                :text-inside="true"
                size="small"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="失败原因" width="200">
            <template slot-scope="scope">
              <span v-if="uploadFileErrorMsgMap[scope.row.uid]" style="color: #F56C6C; font-size: 12px;">{{ uploadFileErrorMsgMap[scope.row.uid] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button
                v-if="!isUploading && uploadFileStatusMap[scope.row.uid] !== 'success' && uploadFileStatusMap[scope.row.uid] !== 'uploading' && uploadFileStatusMap[scope.row.uid] !== 'hashing' && uploadFileStatusMap[scope.row.uid] !== 'merging'"
                type="text"
                size="small"
                @click="removeUploadFile(scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseUploadDialog">关 闭</el-button>
        <el-button type="primary" @click="startChunkUpload" :loading="isUploading" :disabled="isUploading">开始上传</el-button>
      </span>
    </el-dialog>

    <!-- 编辑照片弹窗 -->
    <el-dialog
      title="编辑照片"
      :visible.sync="editPhotoDialogVisible"
      width="500px"
      :before-close="() => editPhotoDialogVisible = false"
    >
      <el-form :model="editPhotoForm" :rules="editPhotoRules" ref="editPhotoForm" label-width="80px">
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="editPhotoForm.description"
            type="textarea"
            :rows="4"
            placeholder="请输入描述"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPhotoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditPhoto" :loading="editPhotoLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import { LIST_PAGE_MAX_SIZE, URL_PATH } from "@/config/config";
import Sortable from 'sortablejs';

export default {
  name: 'AssociationAlbum',
  data() {
    return {
      // 视图模式：list=相册列表，detail=相册详情
      viewMode: 'list',
      // === 相册列表相关 ===
      loading: false,
      dataList: [],
      searchForm: {
        search: '',
        screen_is_show: '',
        screen_start_date: '',
        screen_end_date: ''
      },
      dateRange: [],
      elementui_page_key: 0,
      pageCount: 0,
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      // 创建/编辑相册相关
      createDialogVisible: false,
      createLoading: false,
      isEdit: false,
      editId: null,
      createForm: {
        title: '',
        description: '',
        is_show: 0
      },
      createRules: {
        title: [
          { required: true, message: '请输入相册标题', trigger: 'blur' }
        ]
      },
      // === 相册详情相关 ===
      currentAlbumId: null,
      albumInfo: {},
      detailLoading: false,
      photoList: [],
      // 预览相关
      videoPreviewVisible: false,
      videoPreviewUrl: '',
      currentPreviewRow: null,
      // === 分片上传相关 ===
      uploadDialogVisible: false,
      uploadFileList: [],
      uploadFileStatusMap: {},  // uid -> 'pending'|'hashing'|'uploading'|'merging'|'success'|'error'
      uploadFileProgressMap: {}, // uid -> 0~100
      uploadFileHashkMap: {},   // uid -> file sha256 hash
      uploadFileErrorMsgMap: {}, // uid -> error message
      isUploading: false,       // 全局上传锁，防止重复点击
      // === 编辑照片相关 ===
      editPhotoDialogVisible: false,
      editPhotoLoading: false,
      editPhotoId: null,
      editPhotoForm: {
        description: ''
      },
      editPhotoRules: {
        description: [
          { max: 200, message: '描述不能超过200个字符', trigger: 'blur' }
        ]
      },
      // === 拖拽排序相关 ===
      sortableInstance: null,
      sortSaving: false,
      sortChanged: false,
      originalPhotoList: []
    };
  },
  created() {
    this.getList();
  },
  computed: {
    associationId() {
      return this.$route.query.id;
    }
  },
  methods: {
    // 获取相册列表
    getList() {
      this.loading = true;
      const params = {
        token: localStorage.getItem("token"),
        association_id: this.$route.query.id,
        page: this.currentPage,
        limit: this.pageMaxSize,
        search: this.searchForm.search,
        screen_is_show: this.searchForm.screen_is_show,
        screen_start_date: this.searchForm.screen_start_date,
        screen_end_date: this.searchForm.screen_end_date
      };
      this.$api
        .adminAppletsAssociationPhotoAlbumList(params)
        .then(({ data }) => {
          if (data && data.Data) {
            let current_page = Utils.listPage(data, this.currentPage);
            if (current_page) {
              this.currentPage = current_page;
              this.getList();
              return;
            }
            this.pageCount = data.Data.pageCount;
            this.dataList = data.Data.model || [];
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索
    handleSearch() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.searchForm.screen_start_date = this.dateRange[0];
        this.searchForm.screen_end_date = this.dateRange[1];
      } else {
        this.searchForm.screen_start_date = '';
        this.searchForm.screen_end_date = '';
      }
      this.currentPage = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        search: '',
        screen_is_show: '',
        screen_start_date: '',
        screen_end_date: ''
      };
      this.dateRange = [];
      this.currentPage = 1;
      this.getList();
    },
    // 分页切换
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 显示创建相册弹窗
    handleCreate() {
      this.isEdit = false;
      this.editId = null;
      this.resetCreateForm();
      this.createDialogVisible = true;
    },
    // 关闭创建/编辑弹窗
    handleCloseCreateDialog() {
      this.createDialogVisible = false;
      this.isEdit = false;
      this.editId = null;
      this.resetCreateForm();
    },
    // 重置表单
    resetCreateForm() {
      this.createForm = {
        title: '',
        description: '',
        is_show: 0
      };
      if (this.$refs.createForm) {
        this.$refs.createForm.clearValidate();
      }
    },
    // 提交创建/编辑
    submitCreate() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          const params = {
            token: localStorage.getItem('token'),
            title: this.createForm.title,
            description: this.createForm.description || '',
            is_show: this.createForm.is_show
          };
          if (this.isEdit) {
            params.id = this.editId;
          } else {
            params.association_id = this.$route.query.id;
          }
          const apiMethod = this.isEdit
            ? 'adminAppletsAssociationPhotoEditAlbum'
            : 'adminAppletsAssociationPhotoCreateAlbum';
          this.$api
            [apiMethod](params)
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success(this.isEdit ? '编辑成功' : '创建成功');
                this.handleCloseCreateDialog();
                this.getList();
              }
            })
            .catch(({ error }) => {})
            .finally(() => {
              this.createLoading = false;
            });
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.editId = row.id;
      this.createForm = {
        title: row.title || '',
        description: row.description || '',
        is_show: row.is_show
      };
      this.createDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('是否删除此相册?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .adminAppletsAssociationPhotoDeleteAlbum({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // ========== 相册详情相关 ==========
    // 进入相册详情
    enterAlbum(row) {
      this.currentAlbumId = row.id;
      this.albumInfo = {
        title: row.title,
        description: row.description
      };
      this.viewMode = 'detail';
      this.getPhotoList();
    },
    // 返回相册列表
    backToList() {
      // 销毁拖拽实例
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
        this.sortableInstance = null;
      }
      this.viewMode = 'list';
      this.currentAlbumId = null;
      this.albumInfo = {};
      this.getList();
    },
    // 获取照片/视频列表（全部，不分页）
    getPhotoList() {
      this.detailLoading = true;
      this.$api
        .adminAppletsAssociationPhotoAlbumDetail({
          token: localStorage.getItem('token'),
          album_id: this.currentAlbumId
        })
        .then(({ data }) => {
          if (data && data.Data) {
            this.albumInfo = data.Data.album || this.albumInfo;
            this.photoList = data.Data.model || [];
            this.originalPhotoList = [...this.photoList];
            this.sortChanged = false;
            this.$nextTick(() => {
              this.initSortable();
            });
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.detailLoading = false;
        });
    },
    // 初始化拖拽排序
    initSortable() {
      // 先销毁旧实例
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
        this.sortableInstance = null;
      }
      const el = this.$refs.photoTable;
      if (!el) return;
      const tbody = el.$el.querySelector('.el-table__body-wrapper tbody');
      if (!tbody) return;
      this.sortableInstance = Sortable.create(tbody, {
        animation: 150,
        handle: '.drag-handle',
        onEnd: ({ oldIndex, newIndex }) => {
          if (oldIndex === newIndex) return;
          // 更新本地数组顺序
          const movedItem = this.photoList.splice(oldIndex, 1)[0];
          this.photoList.splice(newIndex, 0, movedItem);
          // 标记排序已变更
          this.sortChanged = true;
        }
      });
    },
    // 保存排序到后端
    saveSort() {
      const photoIds = this.photoList.map(item => item.id);
      this.sortSaving = true;
      this.$api
        .adminAppletsAssociationPhotoSortPhoto({
          token: localStorage.getItem('token'),
          album_id: this.currentAlbumId,
          photo_ids: photoIds
        })
        .then(({ data }) => {
          if (data && data.Code === 0) {
            this.$message.success(data.Msg || '排序成功');
            this.sortChanged = false;
            // 重新加载列表以获取最新的sort字段
            this.getPhotoList();
          }
        })
        .catch(({ error }) => {
          this.$message.error('排序保存失败');
        })
        .finally(() => {
          this.sortSaving = false;
        });
    },
    // 取消排序，恢复原始顺序
    cancelSort() {
      this.photoList = [...this.originalPhotoList];
      this.sortChanged = false;
      // 重新初始化拖拽（DOM已变）
      this.$nextTick(() => {
        this.initSortable();
      });
    },
    // 拼接文件完整URL
    getFileUrl(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return URL_PATH + path.replace(/^\//, '');
    },
    // 预览（仅视频走弹窗，图片由el-image自带预览）
    previewItem(row) {
      this.currentPreviewRow = row;
      const url = this.getFileUrl(row.file_path);
      if (row.is_video) {
        this.videoPreviewUrl = url;
        this.videoPreviewVisible = true;
      }
    },
    // 关闭视频预览（停止播放）
    closeVideoPreview() {
      this.videoPreviewVisible = false;
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause();
        this.$refs.previewVideo.currentTime = 0;
      }
      this.currentPreviewRow = null;
    },
    // 下载文件（后端下载接口，<a>标签GET方式）
    downloadPhoto(row) {
      const token = localStorage.getItem('token');
      const url = `${URL_PATH}api/adminAppletsAssociationPhoto/downloadPhoto?token=${token}&photo_id=${row.id}`;
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 下载相册（打包ZIP，表单提交方式）
    downloadAlbum() {
      const token = localStorage.getItem('token');
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `${URL_PATH}api/adminAppletsAssociationPhoto/downloadAlbum`;
      form.style.display = 'none';
      const addField = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      };
      addField('token', token);
      addField('album_id', this.currentAlbumId);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    // 打开上传弹窗
    handleUploadPhoto() {
      this.uploadDialogVisible = true;
    },
    // 关闭上传弹窗
    handleCloseUploadDialog() {
      if (this.isUploading) {
        this.$message.warning('文件上传中，请等待完成');
        return;
      }
      this.uploadDialogVisible = false;
      // 清空上传状态
      this.uploadFileList = [];
      this.uploadFileStatusMap = {};
      this.uploadFileProgressMap = {};
      this.uploadFileHashkMap = {};
      this.uploadFileErrorMsgMap = {};
      if (this.$refs.photoUpload) {
        this.$refs.photoUpload.clearFiles();
      }
    },
    // 文件选择变化
    handleUploadFileChange(file, fileList) {
      this.uploadFileList = fileList;
      // 新增的文件默认状态为 pending
      if (!this.uploadFileStatusMap[file.uid]) {
        this.$set(this.uploadFileStatusMap, file.uid, 'pending');
        this.$set(this.uploadFileProgressMap, file.uid, 0);
      }
    },
    // 文件移除
    handleUploadFileRemove(file, fileList) {
      this.uploadFileList = fileList;
      this.$delete(this.uploadFileStatusMap, file.uid);
      this.$delete(this.uploadFileProgressMap, file.uid);
      this.$delete(this.uploadFileHashkMap, file.uid);
      this.$delete(this.uploadFileErrorMsgMap, file.uid);
    },
    // 删除文件（列表中）
    removeUploadFile(index) {
      const file = this.uploadFileList[index];
      this.$delete(this.uploadFileStatusMap, file.uid);
      this.$delete(this.uploadFileProgressMap, file.uid);
      this.$delete(this.uploadFileHashkMap, file.uid);
      this.$delete(this.uploadFileErrorMsgMap, file.uid);
      this.uploadFileList.splice(index, 1);
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const units = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + units[i];
    },

    // ========== 分片上传核心逻辑 ==========
    // 计算文件SHA256哈希
    computeFileHash(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const buffer = e.target.result;
            const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            resolve(hashHex);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        reader.readAsArrayBuffer(file);
      });
    },

    // 开始分片上传（串行，一个文件完成后再下一个）
    async startChunkUpload() {
      // 过滤：只上传非成功的文件（pending + error）
      const filesToUpload = this.uploadFileList.filter(file => {
        const status = this.uploadFileStatusMap[file.uid];
        return status !== 'success';
      });

      if (filesToUpload.length === 0) {
        this.$message.info('没有需要上传的文件');
        return;
      }

      // 上传锁
      if (this.isUploading) return;
      this.isUploading = true;

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        try {
          await this.uploadSingleFileChunked(file);
        } catch (err) {
          // 单文件失败不中断，继续下一个
        }
      }

      this.isUploading = false;

      // 统计结果
      const successCount = filesToUpload.filter(f => this.uploadFileStatusMap[f.uid] === 'success').length;
      const failCount = filesToUpload.filter(f => this.uploadFileStatusMap[f.uid] === 'error').length;

      if (failCount === 0) {
        this.$message.success(`全部上传成功，共 ${successCount} 个文件`);
      } else {
        this.$message.warning(`上传完成，成功 ${successCount} 个，失败 ${failCount} 个`);
      }

      // 刷新照片列表
      this.getPhotoList();
    },

    // 单文件分片上传
    async uploadSingleFileChunked(fileObj) {
      const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
      const file = fileObj.raw;
      const uid = fileObj.uid;

      // 步骤1：计算哈希
      this.$set(this.uploadFileStatusMap, uid, 'hashing');
      this.$set(this.uploadFileProgressMap, uid, 0);
      this.$set(this.uploadFileErrorMsgMap, uid, '');

      let fileHash;
      try {
        fileHash = await this.computeFileHash(file);
        this.uploadFileHashkMap[uid] = fileHash;
      } catch (err) {
        this.$set(this.uploadFileStatusMap, uid, 'error');
        this.$set(this.uploadFileErrorMsgMap, uid, '文件哈希计算失败');
        throw err;
      }

      // 步骤2：分片上传
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
      this.$set(this.uploadFileStatusMap, uid, 'uploading');

      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunkBlob = file.slice(start, end);

        const formData = new FormData();
        formData.append('token', localStorage.getItem('token'));
        formData.append('album_id', this.currentAlbumId);
        formData.append('file_hash', fileHash);
        formData.append('chunk_index', chunkIndex);
        formData.append('total_chunks', totalChunks);
        formData.append('chunk', chunkBlob, fileObj.name);

        try {
          const response = await this.uploadChunkRequest(formData);
          if (response.Code !== 0) {
            throw new Error(response.Msg || '分片上传失败');
          }
        } catch (err) {
          this.$set(this.uploadFileStatusMap, uid, 'error');
          this.$set(this.uploadFileErrorMsgMap, uid, err.message || '分片上传失败');
          throw err;
        }

        // 更新进度：分片上传占 0~90%
        const chunkProgress = Math.round(((chunkIndex + 1) / totalChunks) * 90);
        this.$set(this.uploadFileProgressMap, uid, chunkProgress);
      }

      // 步骤3：合并分片
      this.$set(this.uploadFileStatusMap, uid, 'merging');
      this.$set(this.uploadFileProgressMap, uid, 95);

      const fileName = fileObj.name;
      const fileExt = fileName.includes('.') ? fileName.split('.').pop() : '';

      try {
        const mergeResult = await this.mergeChunksRequest({
          token: localStorage.getItem('token'),
          album_id: this.currentAlbumId,
          upload_id: fileHash,
          file_hash: fileHash,
          file_name: fileName,
          file_size: file.size,
          file_ext: fileExt,
          total_chunks: totalChunks
        });

        if (mergeResult.Code !== 0) {
          throw new Error(mergeResult.Msg || '合并失败');
        }

        this.$set(this.uploadFileStatusMap, uid, 'success');
        this.$set(this.uploadFileProgressMap, uid, 100);
      } catch (err) {
        this.$set(this.uploadFileStatusMap, uid, 'error');
        this.$set(this.uploadFileErrorMsgMap, uid, err.message || '分片合并失败');
        throw err;
      }
    },

    // 分片上传请求（使用原始axios，发送FormData）
    uploadChunkRequest(formData) {
      return new Promise((resolve, reject) => {
        const axiosBase = require('axios');
        const axios = axiosBase.create({
          baseURL: URL_PATH,
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 300000 // 5分钟超时
        });
        axios.post('api/adminAppletsAssociationPhoto/uploadPhotoChunk', formData)
          .then(response => resolve(response.data))
          .catch(error => {
            if (error.response && error.response.data) {
              reject(new Error(error.response.data.Msg || '分片上传失败'));
            } else {
              reject(new Error(error.message || '网络错误'));
            }
          });
      });
    },

    // 合并请求
    mergeChunksRequest(params) {
      return new Promise((resolve, reject) => {
        this.$api.adminAppletsAssociationPhotoMergeChunks(params)
          .then(({ data }) => resolve(data))
          .catch(({ error }) => {
            reject(new Error(error || '合并请求失败'));
          });
      });
    },
    // 编辑照片
    handleEditPhoto(row) {
      this.editPhotoId = row.id;
      this.editPhotoForm = {
        description: row.description || ''
      };
      this.editPhotoDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.editPhotoForm) {
          this.$refs.editPhotoForm.clearValidate();
        }
      });
    },
    // 提交编辑照片
    submitEditPhoto() {
      this.$refs.editPhotoForm.validate((valid) => {
        if (valid) {
          this.editPhotoLoading = true;
          this.$api
            .adminAppletsAssociationPhotoEditPhoto({
              token: localStorage.getItem('token'),
              photo_id: this.editPhotoId,
              description: this.editPhotoForm.description
            })
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success(data.Msg || '编辑成功');
                this.editPhotoDialogVisible = false;
                this.getPhotoList();
              }
            })
            .catch(({ error }) => {})
            .finally(() => {
              this.editPhotoLoading = false;
            });
        }
      });
    },
    // 删除照片
    handleDeletePhoto(row) {
      this.$confirm('是否删除此照片/视频?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .adminAppletsAssociationPhotoDeletePhoto({
              token: localStorage.getItem('token'),
              photo_id: row.id
            })
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success(data.Msg || '删除成功');
                this.getPhotoList();
              }
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-top: 16px;
}
.elPagination {
  margin-top: 16px;
  text-align: center;
}
.thumbnail-video {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  i {
    font-size: 28px;
    color: #409EFF;
  }
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #ccc;
  font-size: 20px;
}
.drag-handle {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  cursor: move;
  margin-right: 6px;
  vertical-align: middle;
  height: 16px;
  span {
    display: block;
    width: 12px;
    height: 2px;
    background: #c0c4cc;
    border-radius: 1px;
  }
  &:hover span {
    background: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/associationAlbum.vue